/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Tag, Popover, Button, Portal, Separator } from '@welbe/design-system';
import { LuPlusCircle, LuChevronLeft } from 'react-icons/lu';

type FilterPopoverProps = {
	label: string;
	hasValue: boolean;
	displayValue?: string;
	onClear?: () => void;
	children: React.ReactNode;
};

export const FilterPopover = ({
	label,
	hasValue,
	displayValue,
	onClear,
	children,
}: FilterPopoverProps) => {
	return (
		<Popover.Root positioning={{ placement: 'bottom-start' }}>
			{/* @ts-ignore */}
			<Popover.Trigger asChild>
				<Tag.Root
					size="lg"
					variant={hasValue ? 'surface' : 'outline'}
					cursor="pointer"
					_hover={{ bg: 'blue.50' }}
					h="28px"
				>
					<Tag.StartElement hidden={hasValue}>
						<LuPlusCircle />
					</Tag.StartElement>
					<Tag.Label fontSize="xs" fontWeight="600">
						{hasValue ? displayValue : label}
					</Tag.Label>
					<Tag.EndElement hidden={!hasValue || Boolean(!onClear)}>
						<Tag.CloseTrigger
							onClick={(e) => {
								e.stopPropagation();
								onClear?.();
							}}
							_hover={{ bg: 'blue.300', color: 'white' }}
						/>
					</Tag.EndElement>
				</Tag.Root>
			</Popover.Trigger>
			<Portal>
				<Popover.Positioner>
					<Popover.Content>
						{/* @ts-ignore */}
						<Popover.Title display="flex" justifyContent="space-between">
							{/* @ts-ignore */}
							<Popover.Trigger asChild>
								<Button variant="plain" size="xs" p="0 0.5rem">
									<LuChevronLeft />
									Regresar
								</Button>
							</Popover.Trigger>
						</Popover.Title>
						<Separator />
						<Popover.Body p="1rem">{children}</Popover.Body>
					</Popover.Content>
				</Popover.Positioner>
			</Portal>
		</Popover.Root>
	);
};
